import styled from "styled-components";
import Star from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";
import StarHalf from "@mui/icons-material/StarHalf";

interface IStarIconProps {
	isEmpty?: boolean;
	isHalf?: boolean;
}

const Container = styled.div`
	.MuiSvgIcon-root {
		color: #fab01c;
	}
`;

function StarIcon({ isHalf = false, isEmpty = false }: IStarIconProps) {
	return <Container>{isEmpty ? <StarBorder /> : isHalf ? <StarHalf /> : <Star />}</Container>;
}

export { StarIcon };
